import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AccountMenu from '../../Modules/AccountMenu'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/workingexperiences/sendmails"
class WerkervaringControle extends Component {
	constructor(props) {
		super(props)
		this.handleClick = this.handleClick.bind(this)
	}

	handleClick(event) {
		Api.PostApi(FETCH_URL, {}, this.props.history).then(data => {
			alert("E-mail is verstuurd naar referentie.")
		})
	}
	render() {
		return (
			<div className="route">
				<AccountMenu />
				<div className="grey-bg">
					<h1 className="pageTitle">
						Controle van werkervaring
            		</h1>
					<p>U kunt hier uw werkervaring laten controleren door uw referenties. Iedere referent die u aan een werkervaringsregel heeft gekoppeld ontvangt een email met een uitnodiging om de door u ingevoerde regels te controleren.</p>

					<p>Als een referentie niet akkoord gaat met een opgegeven ervaring wordt deze regel uit uw werkervaring verwijderd. U ontvangt hierover dan een email. Als de referentie de ervaring goedkeurt wordt het aantal punten bij uw ervaring opgeleld.</p>
					<p><Button type="button" onClick={this.handleClick}>Stuur referenties nu een email</Button></p>
					<p><Link to="/werkervaring/beheren">Terug naar werkervaring</Link></p>
				</div>
			</div>
		);
	}
}

export default WerkervaringControle;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Werkervaring/WerkervaringControle.js